import React from 'react';

import styles from './StationFilterChips.scss';

interface StationFilterChipsProps {
    className?: string;
    isDepartureFiltered: boolean;
    isArrivalFiltered: boolean;
    filteredCount: number;
    totalCount: number;
    onResetDeparture: () => void;
    onResetArrival: () => void;
    onResetAll: () => void;
}

function StationFilterChips({
    className,
    isDepartureFiltered,
    isArrivalFiltered,
    filteredCount,
    totalCount,
    onResetDeparture,
    onResetArrival,
    onResetAll,
}: StationFilterChipsProps) {
    if (!isDepartureFiltered && !isArrivalFiltered) {
        return null;
    }

    return (
        <div className={`${styles.container}${className
            ? ` ${className}`
            : ''}`}>
            <div className={styles.left}>
                <span className={styles.label}>
                    Filtered by stop
                </span>
                {isDepartureFiltered && (
                    <button
                        className={styles.chip}
                        onClick={onResetDeparture}
                        type="button"
                    >
                        <span className={styles.chipName}>Departure stop</span>
                        <span aria-label="Remove filter" className={styles.chipRemove}>&times;</span>
                    </button>
                )}
                {isArrivalFiltered && (
                    <button
                        className={styles.chip}
                        onClick={onResetArrival}
                        type="button"
                    >
                        <span className={styles.chipName}>Arrival stop</span>
                        <span aria-label="Remove filter" className={styles.chipRemove}>&times;</span>
                    </button>
                )}
                <span className={styles.count}>
                    Showing {filteredCount} of {totalCount} trips
                </span>
            </div>
            <button
                className={styles.clearAll}
                onClick={onResetAll}
                type="button"
            >
                Clear all
            </button>
        </div>
    );
}

export default React.memo(StationFilterChips);
